<template>
    <li class="c-history_item">
        <div class="c-history_item__heading">
            <span class="c-history_item__heading-date">{{ getDate }}</span>
            <span class="c-history_item__heading-author">{{ getAuthor }}</span>
        </div>
        <div class="c-history_item__content">
            <slot></slot>
        </div>
    </li>
</template>


<script>

import moment from 'moment'

export default {

    name: 'VisitHistoryItem',

    props: {
        date: String,
        author: Object
    },

    computed: {
        getAuthor() {
            return this.author.first_name + ' ' + this.author.last_name
        },
        getDate() {
            return moment(this.date).format('DD.MM.YYYY, HH:mm:ss')
        }
    }

}
</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-history_item {
    border-bottom: 1px solid $c-border;
    padding: 0 1rem;

    @include bp($screen-sm) {
        padding: 0;
    }
    &:last-of-type {
        border: 0;
    }
    &__heading {
        margin-top: 1rem;

        &-date {
            margin-right: 1rem;
            color: #D9D9DE;
        }
        &-author {
            margin-right: 1rem;
            font-size: 0.9rem;
            color: $c-primary;
            word-wrap: nowrap;
        }
    }
    &__content {
        margin: 1rem 0;
        line-height: 1.5;
        text-align: justify;
        color: #9FA9BA;
        min-height: 1.5rem;
    }
}

</style>
